import { render, staticRenderFns } from "./GroupButtons.vue?vue&type=template&id=ffdbd168&scoped=true&"
import script from "./GroupButtons.vue?vue&type=script&lang=js&"
export * from "./GroupButtons.vue?vue&type=script&lang=js&"
import style0 from "./GroupButtons.vue?vue&type=style&index=0&id=ffdbd168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdbd168",
  null
  
)

export default component.exports